exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3y3ax6R4OKN8dCNbIQSonT{border:1px solid #e0e0e0;border-radius:2px}._26G8eatsy_tWqVI2YAoEao{height:40px;background-color:#eee;display:flex;justify-content:space-between}._3TuQTEZwebsXdCRvIMatYU{display:inline-block;cursor:pointer;line-height:40px;margin:0 10px;color:#424242}._3TuQTEZwebsXdCRvIMatYU:hover{color:#fa6400}._3TuQTEZwebsXdCRvIMatYU._3vmgnQRLHGmBu17IsH1FW_{color:#9e9e9e}._3TuQTEZwebsXdCRvIMatYU._3vmgnQRLHGmBu17IsH1FW_:hover{color:#9e9e9e}._3QJgEE4h3qJmIjgaIw5JxD{margin-right:5px}._3eJctVd8RBCpzYU_hSf9G{max-height:65vh;overflow:auto;padding:15px}._3eJctVd8RBCpzYU_hSf9G a{text-decoration:underline !important}.D3wkxXtooaMHSHimKVw_U{margin-top:15px}.D3wkxXtooaMHSHimKVw_U a{font-weight:500}\n", ""]);

// Exports
exports.locals = {
	"GuidePageEditor": "_3y3ax6R4OKN8dCNbIQSonT",
	"Toolbar": "_26G8eatsy_tWqVI2YAoEao",
	"ToolbarButton": "_3TuQTEZwebsXdCRvIMatYU",
	"disabled": "_3vmgnQRLHGmBu17IsH1FW_",
	"savingSpinner": "_3QJgEE4h3qJmIjgaIw5JxD",
	"Editor": "_3eJctVd8RBCpzYU_hSf9G",
	"liveInfo": "D3wkxXtooaMHSHimKVw_U"
};